import { Card, Button } from 'antd'
import { AnalysesData, AnalysesDataContainer, CardTitle } from './style'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'
import { formatDateWithoutTime } from '../../helpers'

interface AnalysesProps {
  client?: any; // Client data from GET_PROFESSIONAL_CLIENT query
}

const Analyses = ({ client }: AnalysesProps) => {
  const navigate = useNavigate();
  const { user } = useSelector((state: RootState) => state.auth) as { user: any };
  
  // Extract analyses data from the client object
  const isClient = user?.role === 'Client' || user?.__typename === 'Client';
  
  const hmaData = client?.hairAndMineralAnalyses?.filter((item: any) => isClient ? item.clientViewable : (item.professionalViewable || item.clientViewable)) || [];
  const hrvData = client?.heartRateVariabilities?.filter((item: any) => isClient ? item.clientViewable : (item.professionalViewable || item.clientViewable)) || [];
  const irCombiData = client?.irCombis?.filter((item: any) => isClient ? item.clientViewable : (item.professionalViewable || item.clientViewable)) || [];
  const iodineData = client?.iodineTests?.filter((item: any) => item.clientViewable) || [];
  
  const professionalCode = client?.professionalCode;
  const userCode = user?.code || professionalCode;
  const routePrefix = isClient ? `/c/${userCode}` : `/p/${professionalCode}`;

  const handleAnalysisClick = (type: string, item: any) => {
    let path = '';
    switch (type) {
      case 'hma':
        path = `${routePrefix}/hma_results/${item.id}`;
        break;
      case 'hrv':
        path = `${routePrefix}/hrv_reports/${item.id}`;
        break;
      case 'irCombi':
        path = `${routePrefix}/ir_combis/${item.id}`;
        break;
      case 'iodine':
        path = `${routePrefix}/iodine_tests/${item.id}`;
        break;
    }
    if (path) {
      sessionStorage.setItem(`analysis_payload_${item.id}`, JSON.stringify(item));
      window.open(path, '_blank');
    }
  };

  const categories = [
    { title: 'Hair and Mineral analysis', data: hmaData, type: 'hma' },
    { title: 'Heart Rate Variability', data: hrvData, type: 'hrv' },
    { title: 'IR Combi', data: irCombiData, type: 'irCombi' },
    { title: 'Iodine Test', data: iodineData, type: 'iodine' },
  ];

  return (
    <Card>
      <CardTitle>
        <p>Analyses</p>
      </CardTitle>
      <AnalysesDataContainer>
        {categories.map((cat, catIdx) => (
          <div key={`cat-${catIdx}`}>
            <div style={{ padding: '8px 0', borderTop: '1px solid #e1e8f0', backgroundColor: '#f8fafc' }}>
              <p style={{ margin: 0, paddingLeft: '8px', fontWeight: 700, fontSize: '.875rem' }}>{cat.title}</p>
            </div>
            {cat.data.length > 0 ? (
              cat.data.map((item: any) => (
                <AnalysesData 
                  key={`${cat.type}-${item.id}`}
                  onClick={() => handleAnalysisClick(cat.type, item)}
                  style={{ cursor: 'pointer', paddingLeft: '24px' }}
                >
                  <p>#{item.reportNumber || item.id}</p>
                  <small>{formatDateWithoutTime(item.dateOfAnalysis || item.createdAt)}</small>
                </AnalysesData>
              ))
            ) : (
              <AnalysesData style={{ paddingLeft: '24px', opacity: 0.6 }}>
                <p>Not available yet</p>
              </AnalysesData>
            )}
          </div>
        ))}
      </AnalysesDataContainer>
    </Card>
  )
}

export default Analyses